
import Vue from "vue";
const HomePage = () => import("@/components/HomePage.vue")


export default Vue.extend({
  name: "Home",

  components: {
    HomePage,
    
  },
});
